/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/naming-convention */
import { IFieldNumeric } from "@/@types/models/model";

const total_length: IFieldNumeric = {
  title: "duljina",
  source: "total_length",
  ttoken: "route.duljina",
  type: "numeric",
  suffix: "m",
  readonly: true,
  display: "display_m_to_km"
}

const total_time_min: IFieldNumeric = {
  title: "trajanje",
  source: "total_time_min",
  ttoken: "route.trajanje",
  type: "numeric",
  readonly: true,
  display: "display_hh_mm"
}

const total_ascent: IFieldNumeric = {
  title: "elevation_gain",
  source: "total_ascent",
  ttoken: "route.elevation_gain",
  type: "numeric",
  suffix: "m",
  readonly: true,
  display: "display_m"
}

const total_descent: IFieldNumeric = {
  title: "elevation_loss",
  source: "total_descent",
  ttoken: "route.elevation_loss",
  type: "numeric",
  suffix: "m",
  readonly: true,
  display: "display_m"
}

export const routingFields = {
  total_length,
  total_time_min,
  total_ascent,
  total_descent
};
